import { render } from "./oneMinuteOrder.vue?vue&type=template&id=3f6ecdf0"
import script from "./oneMinuteOrder.vue?vue&type=script&lang=js"
export * from "./oneMinuteOrder.vue?vue&type=script&lang=js"

import "./oneMinuteOrder.vue?vue&type=style&index=0&id=3f6ecdf0&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__